// extracted by mini-css-extract-plugin
export default {"resendContainer":"ConfirmEmail_resendContainer__xElJq"};